import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
// Fix for default marker icon in react-leaflet
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
});
export function Location() {
  const {
    t
  } = useLanguage();
  const position: [number, number] = [33.5806, -111.9322]; // Scottsdale AZ approx coords
  return <section className="py-24 lg:py-40 bg-white" data-id="element-196">
      <div className="container mx-auto px-6" data-id="element-197">
        <div className="grid lg:grid-cols-12 gap-16 lg:gap-24 items-center max-w-6xl mx-auto" data-id="element-198">
          <div className="lg:col-span-4" data-id="element-199">
            <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-200">
              {t('location.eyebrow')}
            </span>
            <h2 className="text-4xl md:text-5xl font-serif font-light text-brand-dark mb-12 tracking-tight" data-id="element-201">
              {t('location.heading')}
            </h2>

            <div className="space-y-10" data-id="element-202">
              <div data-id="element-203">
                <h4 className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50 mb-2" data-id="element-204">
                  {t('location.addressLabel')}
                </h4>
                <p className="font-serif text-lg text-brand-dark/80 leading-relaxed" data-id="element-205">
                  10505 N 69th St
                  <br data-id="element-206" />
                  Suite 1100
                  <br data-id="element-207" />
                  Scottsdale, AZ 85253
                </p>
              </div>

              <div data-id="element-208">
                <h4 className="text-[10px] font-medium tracking-widest uppercase text-brand-dark/50 mb-2" data-id="element-209">
                  {t('location.emailLabel')}
                </h4>
                <p className="font-serif text-lg text-brand-dark/80" data-id="element-210">
                  hello@dermalipophoenix.com
                </p>
              </div>

              <div className="pt-4" data-id="element-211">
                <button onClick={() => document.getElementById('contacto')?.scrollIntoView({
                behavior: 'smooth'
              })} className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/70 hover:text-brand-dark transition-colors inline-flex items-center gap-2 border-b border-brand-gold/40 pb-1" data-id="element-212">
                  {t('nav.cta')} →
                </button>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8 h-[500px] lg:h-[600px] w-full rounded-[2rem] overflow-hidden border border-brand-stone/50 z-0" data-id="element-213">
            <MapContainer center={position} zoom={13} scrollWheelZoom={false} className="w-full h-full" data-id="element-214">
              <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png" data-id="element-215" />
              <Marker position={position} data-id="element-216">
                <Popup data-id="element-217">
                  DermaLipo Phoenix <br data-id="element-218" /> {t('location.address')}
                </Popup>
              </Marker>
            </MapContainer>
          </div>
        </div>
      </div>
    </section>;
}